
import Navbar from '../../navbar/Navbar'
import Footer from '../../footer/Footer';
import MTechLeftTab from '../Mtech/MTechLeftTab';
import React, { Component, useState } from 'react';
import FacultyTable from '../../components/FacultyTable';
import NonTeachingStaff from '../../components/NonTeachingStaff';
import $ from 'jquery';
import '../department.css'
import Loader from '../colorful_loader.gif'

export class MTechFacultyList extends Component {

    state = {
        modal: false
    }
    state = {
        enabled: false
    }


    selectModal = (info) => {
        this.setState({ modal: !this.state.modal, selectedrec: info });
    }

    viewModal = (info) => {
        this.setState({ enabled: !this.state.enabled })
    }

    constructor(props) {
        super(props);
        this.state = { csefaculty: [], loading: true };
        this.handleInputChange = this.handleInputChange.bind(this);

    }
    handleInputChange(event) {
        const target = event.target;
        var value = target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    }
    componentDidMount() {
        this.populateCSEFaculty();
    }


    renderCSEFacultyTable(CSEFacultydata) {
        return <><FacultyTable faculty={CSEFacultydata} /><NonTeachingStaff faculty={CSEFacultydata} /></>;
    }

    isExpandableRow(row) {
        return true;
    }
    refreshData = (data) => {
        this.populateCSEFaculty();
    };
    render() {
        let contents = this.state.loading
            ? /*<p><em>Loading...</em></p>*/ $(".load").show()
            : this.renderCSEFacultyTable(this.state.csefaculty, this.refreshData);
        $(".load").hide()
        return (
            <div >
                <Navbar />
                <div className="graduate-admission pt-lg-5 pt-4 pb-70 ">
                    <div className='container'>
                        <div className="row">
                            <div className="col-lg-3 pe-lg-4 order-2 order-lg-1">
                                <MTechLeftTab />
                            </div>
                            <div className="col-lg-9 ps-lg-4 order-1 order-lg-2">
                                <div className="how-to-apply">
                                    <h2>Teaching Faculty
                                    </h2>
                                    <div className="tabCustom mb-5 mt-2">
                                        <div className="container  px-0 tab-pane active">
                                            <div className={this.state.Message ? "alert alert-danger alert-dismissible text-center numbers-sheet" : "alert alert-success alert-dismissible text-center numbers-sheet d-none"} style={{ marginTop: '18px' }}>
                                                <strong>
                                                    {this.state.Message}
                                                </strong>
                                            </div>
                                            <div className="card custom-card">
                                                <div className="card-body p-2">
                                                    {contents}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="load text-center mx-auto" style={{ 'display': 'block' }}>
                                            <img src={Loader} alt="loading icon" width="150" />
                                            <p className="text-center">Data loading please wait...</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />


            </div>

        )
    }
    async populateCSEFaculty() {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/faculty?department=MTech`, {
            method: 'get',
            // headers: {
            //     'Access-Control-Allow-Credentials':'true',
            //     'Content-Type': 'application/json',
            // }
        });
        if (response.status != '200') {
            this.props.history.push("/");
        }
        else {
            const data = await response.json();
            this.setState({ csefaculty: data.data, loading: false });
        }
    }
}



export default MTechFacultyList;

